import { Component } from 'react';

import CustomLinkButton from "GeneralComponents/CustomLinkButton"
import CarouselItem from "../Carousel.interface"
import Helper from 'Interfaces/Helper'
import ComponentImage from 'GeneralComponents/ComponentImage'
import LimitedContent from 'GeneralComponents/LimitedContent'

import "./Events.css"

export default class EventsCarouselItem extends Component {
    props: any;
    state: CarouselItem
    typeOfEventCarousel: string 
    isDateLegal: boolean
    isLongDate: boolean 

    constructor(props) {
        super(props);

        this.state = {
            ...this.props.carouselItem
        }
        this.typeOfEventCarousel = this.props.typeOfEventCarousel // date, image, icon or none
        this.isDateLegal = Helper.getYear(this.props.carouselItem.createDate) !== 1 //weed out min date
        this.isLongDate = (Helper.getYear(this.props.carouselItem.createDate) > 1800) //decide if to show year or not
    }

    

    render() {       

        return (
            <div className="event_carousel_item" >
            {/*seperator*/}
                <div className="seperator"></div>
            {/*date varient*/}
                {this.typeOfEventCarousel === "date" && <div className="date_contianer bg-pallete-color">
                    {this.isDateLegal && <>
                        <span className="date_contianer_day txt-pallete-color">{Helper.getDay(this.props.carouselItem.createDate)}</span>
                        <span className={this.isLongDate ? "date_contianer_year txt-pallete-color" : "txt-pallete-color date_contianer_month"}>
                            {(this.props.dir === "rtl" ? Helper.getLongMonth(this.props.carouselItem.createDate) : Helper.getMonth(this.props.carouselItem.createDate)) +
                            (this.isLongDate ? " " + Helper.getYear(this.props.carouselItem.createDate) : "")}
                        </span>
                    </>}
                </div>}
            {/*icon varient*/}
                {this.typeOfEventCarousel === "icon" && <div className="icon_contianer bg-pallete-color">
                    <i area-hidden="true" className={(this.state.icon) + " icon txt-pallete-color"}></i>
                </div>}
            {/*image varient*/}
                {this.typeOfEventCarousel === "image" && <ComponentImage
                    image={this.state.image}
                    imageClass="img"
                    mobileImage={this.state.mobileImage}
                    mobileImageClass="img"
                    wrapperDivClass="photo_contianer bg-pallete-color" />}
            {/*information and none varient*/}
                <div className={"info_contianer " + (this.typeOfEventCarousel === "none" ? "none_info_container" : "")}>
            {/*title*/}
                    <h3 className="info_contianer_title">{this.state.title}</h3>
            {/*information from RichDescription or Content if RichDescription not available*/}
                    <div className="info_contianer_description_placeholder">
                        {this.state.richDescription ? <LimitedContent htmlContent={this.state.richDescription} classNames="info_contianer_description" /> :
                            <LimitedContent htmlContent={this.state.content} classNames="info_contianer_description" />}
                    </div>
            {/*link*/}
                    <div className="link_placeholder">
                        <CustomLinkButton
                            pageUrl={this.state.url}
                            link={this.state.link}
                            isBtn={false}
                            linkClass={"link txt-pallete-color"}
                            dir={this.props.dir}
                            linkIcon={true} />
                    </div>
                </div>
            </div>
        )
    }
}